import type { ProductItemId } from './types';

export const cartStoreName = 'appCommonCart/cart';

export const ALL_PRODUCTS_IDS: ProductItemId =
  'ALL_PRODUCTS_IDS';
